import { Action, ActionType } from './actions'
import { StateContext } from './store'

export const reducer = (state: StateContext, action: Action) => {
  switch (action.type) {
    case ActionType.SetHookInstanceId:
      return { ...state, hookInstanceId: action.payload }
    case ActionType.SetMedication:
      return { ...state, medication: action.payload }
    case ActionType.SetCards:
      return { ...state, cards: action.payload }
    case ActionType.SetCdsServices:
      return { ...state, cdsServices: action.payload }
    case ActionType.AddError:
      return Array.isArray(action.payload) ?
        { ...state, errors: action.payload } :
        { ...state, errors: [action.payload] }
    case ActionType.ResetErrors:
      return { ...state, errors: [] }
    case ActionType.SetServerDebugInfo:
      return { ...state, serverDebugInfo: action.payload }
    case ActionType.SetMedicationRequest:
      return { ...state, medicationRequest: action.payload }
    case ActionType.SetAdministrations:
      return { ...state, administrations: action.payload }
    case ActionType.SetPrefetchLoaded:
      return { ...state, prefetchLoaded: action.payload }
    case ActionType.SetServicesLoaded:
      return { ...state, servicesLoaded: action.payload }
    case ActionType.SetMedicationPopulated:
      return { ...state, medicationPopulated: action.payload }
    default:
      throw new Error(`Action ${action} Not among actions`)
  }
}
